export default "__VITE_ASSET__Cx4xWG3V__"